import React, { Component } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import NewsImageUpload from "../last-news/NewsImageUpload";
import CloseButton from "./CloseButton";
import { handleEditPartner } from "../../actions/partners";
import { uploadMedia } from "../../utils/api";

class EditPartnerModal extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
  };

  state = {
    title_ar: "",
    title_en: "",
    submitDisabled: true,
    files: [],
    imagePath: "",
    imageLoading: true,
  };

  handleSubmitDisabled = () => {
    const { title_ar, title_en, submitDisabled, imagePath } = this.state;
    if (!title_ar || !title_en || (!imagePath && !submitDisabled)) this.setState({ submitDisabled: true });
    if (title_ar && title_en && imagePath && submitDisabled) this.setState({ submitDisabled: false });
  };
  handleTitleArChange = (e) => {
    this.setState({ title_ar: e.target.value }, this.handleSubmitDisabled);
  };
  handleTitleEnChange = (e) => {
    this.setState({ title_en: e.target.value }, this.handleSubmitDisabled);
  };
  handleSetFiles = (files) => {
    this.setState(
      { files },
      () => {
        const { files } = this.state;
        const form = new FormData();
        form.append("file", files[0]);
        form.append("mime_type", "image");

        uploadMedia(form)
          .then((res) => res.json())
          .then((res) => {
            this.setState({ imagePath: res.path, imageLoading: false });
          });
      },
      this.handleSubmitDisabled
    );
  };

  componentDidUpdate(oldProps) {
    if (oldProps.targetPartner !== this.props.targetPartner) {
      const { targetPartner } = this.props;
      const partnerTitle_ar = targetPartner ? targetPartner.title.ar : "";
      const partnerTitle_en = targetPartner ? targetPartner.title.en : "";
      const partnerImage = targetPartner ? targetPartner.image : "";
      this.setState(
        {
          title_ar: partnerTitle_ar,
          title_en: partnerTitle_en,
          imagePath: partnerImage,
        },
        this.handleSubmitDisabled
      );
    }
  }

  componentDidMount() {
    const { targetPartner } = this.props;
    if (targetPartner)
      this.setState(
        {
          title_ar: targetPartner.title.ar,
          title_en: targetPartner.title.en,
          imagePath: targetPartner.image,
        },
        this.handleSubmitDisabled
      );
  }

  handleSubmit = () => {
    const { updatePartner, handleClose, editId } = this.props;
    const { title_ar, title_en, imagePath } = this.state;
    const data = {
      title: {
        ar: title_ar,
        en: title_en,
      },
      image: imagePath,
    };
    updatePartner(editId, data);
    handleClose();
  };

  render() {
    const { open, handleClose } = this.props;
    const { title_ar, title_en, submitDisabled, files, imagePath, imageLoading } = this.state;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{
          paper: "dialog",
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <CloseButton handleClose={handleClose} />
        <DialogTitle id="responsive-dialog-title" className="text-center">
          تعديل الشريك
        </DialogTitle>
        <DialogContent>
          <div className="form-group">
            <NewsImageUpload files={files} setFiles={this.handleSetFiles} loading={imageLoading} image={imagePath} />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="اسم الشريك بالعربية"
              className="form-control"
              required
              value={title_ar}
              onChange={this.handleTitleArChange}
              variant="outlined"
              size="small"
            />
          </div>
          <div className="form-group">
            <TextField
              type="text"
              placeholder="اسم الشريك بالانجليزية"
              className="form-control"
              required
              value={title_en}
              onChange={this.handleTitleEnChange}
              variant="outlined"
              size="small"
            />
          </div>
        </DialogContent>
        <DialogActions className="justify-content-center align-items-center">
          <Button
            onClick={this.handleSubmit}
            color="primary"
            variant="contained"
            className="dialog__btn"
            disabled={submitDisabled}
          >
            حفظ
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = ({ partners }, { editId }) => {
  const targetPartner = partners.find((item) => item.id === editId);
  return { targetPartner };
};

const mapDispatchToProps = (dispatch) => ({
  updatePartner: (id, data) => dispatch(handleEditPartner(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPartnerModal);
